export const colors = {
  bg: '#04080d',
  bgCard: 'rgba(255,255,255,0.02)',
  bgCardHover: 'rgba(0,255,200,0.04)',
  cyan: '#00ffc8',
  cyanDim: '#00ffc840',
  cyanGlow: '#00ffc860',
  red: '#ff3c6e',
  purple: '#a78bfa',
  text: '#e8f4f2',
  textMid: '#ffffff70',
  textDim: '#ffffff40',
  textFaint: '#ffffff20',
  border: '#ffffff0f',
  borderMid: '#ffffff20',
};

export const fonts = {
  display: "'Orbitron', sans-serif",
  mono: "'Courier New', monospace",
};

export const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: '3px',
  background: 'rgba(255,255,255,0.04)',
  border: `1px solid rgba(255,255,255,0.12)`,
  color: '#e8f4f2',
  fontFamily: "'Courier New', monospace",
  fontSize: '13px',
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 0.2s',
};

export const btnPrimary = (disabled = false) => ({
  fontFamily: "'Orbitron', sans-serif",
  fontSize: '12px',
  fontWeight: 700,
  letterSpacing: '0.12em',
  padding: '11px 22px',
  borderRadius: '3px',
  background: disabled ? 'transparent' : '#00ffc8',
  color: disabled ? '#00ffc840' : '#000',
  border: `1px solid ${disabled ? '#00ffc820' : '#00ffc8'}`,
  cursor: disabled ? 'not-allowed' : 'pointer',
  boxShadow: disabled ? 'none' : '0 0 20px #00ffc830',
  transition: 'all 0.2s',
});

export const CATEGORIES = ['All', 'Tech', 'Design', 'Labor', 'Delivery', 'Writing', 'Odd Jobs', 'Consulting'];

export const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;800;900&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #04080d; color: #e8f4f2; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: #04080d; }
  ::-webkit-scrollbar-thumb { background: #00ffc840; border-radius: 2px; }
  select option { background: #0a1520; color: #e8f4f2; }
  input::placeholder, textarea::placeholder { color: #ffffff25; }
  input:focus, textarea:focus, select:focus { border-color: #00ffc840 !important; outline: none; }
  @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
  @keyframes flicker { 0%,95%,100%{opacity:1} 96%{opacity:0.4} 97%{opacity:1} 98%{opacity:0.6} }
  @keyframes scanH { 0%{transform:translateX(-100%)} 100%{transform:translateX(100%)} }
  @keyframes fadeIn { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
  @keyframes spin { to { transform: rotate(360deg); } }
`;
